import React from 'react';
import { ExpandableListItem } from '../ExpandableListItem';
import { IFailedRecord } from '../../types';
import classes from './FailedRecordsList.tailwind';
import { Title } from '@shared/ui';

interface IFailedRecordsListProps {
  failedRecords: IFailedRecord[];
  'data-id'?: string;
}

export const FailedRecordsList: React.FC<IFailedRecordsListProps> = ({ failedRecords, ...rest }) => {
  return (
    <div className="flex-1 flex flex-col max-h-44">
      <Title text="Error descriptions:" className="text-black text-xl" />
      {failedRecords.length > 0 ? (
        <div className="max-h-40 border rounded-lg overflow-hidden">
          <ul className={classes.listContainer} {...rest}>
            {failedRecords.map((record, index) => (
              <ExpandableListItem
                data-id={`list-item-${index}`}
                source={record.source}
                messages={record.messages}
                key={index}
              />
            ))}
          </ul>
        </div>
      ) : (
        <div data-id="no-errors-occurred" className={`border flex-1 rounded-lg overflow-hidden p-2`}>
          No errors occurred.
        </div>
      )}
    </div>
  );
};
